export enum FieldType {
  SELECT = 'select',
  EDIT = 'edit',
}
